import axios from 'axios';
import SessionStorage from 'core/util/session.storage';

const initAxios = (apiTimeout) => {
    axios.defaults.timeout = apiTimeout;

    axios.defaults.paramsSerializer = {
        encode: (params) => {
            return encodeURI(params);
        },
    };

    const onRequestSuccess = (config) => {
        const token = SessionStorage.getToken();
        const did = SessionStorage.getDid();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            if (!config.params) {
                config.params = {};
            }

            config.params.did = did;
        }




        return config;
    };

    const onResponseSuccess = (response) => response;
    const onResponseError = (error) => {
        //@TODO GLOBAL ACTION on an ERROR CODE 400? 401? 403? 500?
        // const status = error.status || (error.response ? error.response.status : 0);
        return Promise.reject(error);
    };
    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use(onResponseSuccess, onResponseError);




};

export default initAxios;
